export default async function fetchFiraSans(weight: string): Promise<ArrayBuffer> {
  const url = `https://fonts.googleapis.com/css2?family=Fira+Sans:wght@${weight}&display=swap`
  const css = await (await fetch(url)).text()
  const resource = css.match(/src: url\((.+)\) format\('(opentype|truetype)'\)/)
  if (!resource) {
    throw new Error(`Could not find font resource for Fira Sans ${weight}`)
  }
  const fontUrl = resource[1]
  try {
    const res = await fetch(fontUrl!)
    if (!res.ok) {
      throw new Error(`Failed to fetch font at ${fontUrl}`)
    }
    return await res.arrayBuffer()
  } catch (e) {
    console.error(e)
    throw new Error(`Failed to fetch font resource for Fira Sans ${weight}`)
  }
}
